import { useState } from 'react';
import BRAND_LOGO from '../../images/Monitoring_Ronin_Longer.gif';
// import Footer from '../Footer';
import SideBarSmallScreen from '../SideBarSmallScreen';
// import Modal from 'react-bootstrap/Modal';
import NewBusiness from './NewBusiness';
// import Button from 'react-bootstrap/Button';
import {contactNum, contactNumNoSpace, contactEmail, application, webURL} from '../../config';
import OnboardingSite from './OnboardingSite';

// Import generic components
import Modal from '../../generic_components/Modal/Modal';
import Footer from '../../generic_components/Footer/Footer';
import Button from '../../generic_components/Button/Button';

const OnboardingBusiness = ({loading, setLoading}) => {
    let email = window.localStorage.getItem('email');
    const isSmallScreen = window.innerWidth < 600;
    const [reload, setReload] = useState(false);

    const [showNewBusiness, setShowNewBusiness] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    
    const handleCloseNewBusiness = () => {
        setShowNewBusiness(false);
    }

    // const handleShowWarning = () => {
    //     setShowWarning(true);
    // }

    const handleCloseWarning = () => {
        setShowWarning(false);
    }

    const handleCloseWarningAndBusiness = () => {
        setShowWarning(false);
        setShowNewBusiness(false);
    }

    const handleShowNewBusiness = () => {
        setShowNewBusiness(true);
    }

    const handleBusinessSubmit = () => {
        setReload(true);
        // setLoading(false);
    }

    return (
        <>
            {
            reload 
            ? <OnboardingSite />
            :
            <>
            <div className="onboarding-container">
                <div className="logo-container-health">
                    <img src={BRAND_LOGO} alt='SAMURAI' className='home-image-health'></img>
                </div>
                <h2 className="welcome-message">👋 Welcome to {application}!</h2>
                <h4 className="business-message">It seems like you have not created any business with us yet.</h4>
                <div className='guide-container'>
                    <Button className='home-btn-style' size='large' onClick={handleShowNewBusiness}>Create a business</Button>
                </div>

                <div className='contact-container'>
                    <p>Alternatively, you can contact us: </p>
                    <ul className='contact-details'>
                        <li><i className="fa fa-phone"></i><a href={`tel:${contactNumNoSpace}`} className='contact-detail'> {contactNum}</a></li>
                        <li><i className="fa-solid fa-envelope"></i><a href={`mailto:${contactEmail}`} className='contact-detail'> {contactEmail}</a></li>
                    </ul>
                </div> 

                {isSmallScreen && 
                    <SideBarSmallScreen/>
                }

                
            </div>
            
        
            <Modal size='md' show={showNewBusiness} onHide={handleCloseNewBusiness} backdrop="static" keyboard={false} position='center'>
                <Modal.Header className='modal-color-header'>
                    <div className='signup-modal-header-container'>
                    <Modal.Title style={{ fontSize: '1.1rem', fontWeight: '400' }}>Create a new business</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body className='modal-color'>
                    <NewBusiness onBusinessSubmitSuccess={handleBusinessSubmit} onClose={handleCloseNewBusiness} email={email}/>
                </Modal.Body>
            </Modal>
    
            {/* Modal to view warning modal*/}
            <Modal size='md' show={showWarning} onHide={handleCloseWarning} backdrop="static" keyboard={false}>
                <Modal.Header className='modal-color-header'>
                <div className='signup-modal-header-container'>
                <Modal.Title id='delete-user-modal-header'>Are you sure you want to skip creating a business?</Modal.Title>
                </div>
                </Modal.Header>
                <Modal.Body className='modal-color'>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant="danger" size='sm' onClick={handleCloseWarningAndBusiness} style={{ width: '5em' }}>Yes</Button>
                    <Button variant="secondary" size='sm' onClick={handleCloseWarning} style={{ width: '5em' }}>Cancel</Button>
                </div>
                </Modal.Body>
            </Modal>

            <div className='onboarding-business-footer'>
                <Footer url={webURL}/>
            </div>
            </>
            }
        </>
    );
}

export default OnboardingBusiness;